(() => {
function updateFade(el) {
  const max = el.scrollWidth - el.clientWidth;
  const canScroll = max > 1;
  el.classList.toggle('plp-drag-scroll--fade-start', canScroll && el.scrollLeft > 1);
  el.classList.toggle('plp-drag-scroll--fade-end', canScroll && el.scrollLeft < max - 1);
}

function attach(el) {
  if (el._plpDragReady) return;
  el._plpDragReady = true;

  let isDown = false;
  let startX = 0;
  let scrollStart = 0;
  let moved = false;
  let pointerId = null;

  el.addEventListener('pointerdown', (e) => {
    // Only respond to primary mouse button or pen
    if (e.pointerType === 'touch') return;
    if (e.button !== undefined && e.button !== 0) return;
    isDown = true;
    moved = false;
    startX = e.clientX;
    scrollStart = el.scrollLeft;
    pointerId = e.pointerId;
  });

  el.addEventListener('pointermove', (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 4 && !moved) {
      moved = true;
      el.classList.add('is-dragging');
      el.setPointerCapture?.(pointerId);
    }
    el.scrollLeft = scrollStart - dx;
  });

  function release(e) {
    if (!isDown) return;
    isDown = false;
    el.releasePointerCapture?.(e.pointerId);
    if (moved) {
      // Suppress the click that follows a drag so cards don't navigate
      const swallow = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        el.removeEventListener('click', swallow, true);
      };
      el.addEventListener('click', swallow, true);
    }
    requestAnimationFrame(() => el.classList.remove('is-dragging'));
  }

  el.addEventListener('pointerup', release);
  el.addEventListener('pointercancel', release);
  el.addEventListener('pointerleave', release);

  el.addEventListener('wheel', (e) => {
    const max = el.scrollWidth - el.clientWidth;
    if (max <= 1) return;
    if (e.deltaX !== 0) return;
    const step = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? el.clientWidth : 1;
    const delta = e.deltaY * step;
    if (!delta) return;
    if ((delta < 0 && el.scrollLeft <= 0) || (delta > 0 && el.scrollLeft >= max - 1)) return;
    e.preventDefault();
    el.scrollLeft += delta;
  }, { passive: false });

  el.addEventListener('scroll', () => updateFade(el), { passive: true });
  updateFade(el);
  requestAnimationFrame(() => updateFade(el));
}

function bootstrap(root = document) {
  root.querySelectorAll('.plp-series-guide__row, .plp-drag-scroll').forEach(attach);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bootstrap());
} else {
  bootstrap();
}

document.addEventListener('shopify:section:load', () => bootstrap());

window.addEventListener('resize', () => {
  document.querySelectorAll('.plp-drag-scroll, .plp-series-guide__row').forEach(updateFade);
});

// Re-attach when new rows enter the DOM (post-morph)
const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches?.('.plp-series-guide__row, .plp-drag-scroll')) {
        attach(node);
      } else {
        node.querySelectorAll?.('.plp-series-guide__row, .plp-drag-scroll').forEach(attach);
      }
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
})();
